import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './UserMenu.css';

const UserMenu = () => {
    const { user, signOut } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const avatarUrl = user?.user_metadata?.avatar_url;
    const fullName = user?.user_metadata?.full_name || user?.user_metadata?.name || 'User';
    const email = user?.email;

    // Get initials for fallback
    const getInitials = (name) => {
        return name
            .split(' ')
            .map(part => part[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (!user) return null;

    return (
        <div className="user-menu-container" ref={menuRef}>
            <button
                className="user-avatar-btn"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="User menu"
            >
                {avatarUrl ? (
                    <img src={avatarUrl} alt={fullName} className="user-avatar" />
                ) : (
                    <div className="user-avatar-placeholder">
                        {getInitials(fullName)}
                    </div>
                )}
            </button>

            {isOpen && (
                <div className="user-dropdown">
                    <div className="user-info">
                        <div className="user-name">{fullName}</div>
                        <div className="user-email-text">{email}</div>
                    </div>
                    <div className="menu-divider"></div>
                    <Link
                        to="/portfolio"
                        className="menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        My Portfolio
                    </Link>
                    <Link
                        to="/saved?tab=listings"
                        className="menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        Favourites
                    </Link>
                    <Link
                        to="/saved?tab=searches"
                        className="menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        My Buy Boxes
                    </Link>
                    <Link
                        to="/saved?tab=scenarios"
                        className="menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        My Scenarios
                    </Link>
                    <Link
                        to="/saved?tab=comparisons"
                        className="menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        My Comparisons
                    </Link>
                    <div className="menu-divider"></div>
                    <button
                        className="menu-item sign-out"
                        onClick={() => {
                            signOut();
                            setIsOpen(false);
                        }}
                    >
                        Sign Out
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserMenu;

